import React, { Suspense, useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';

import E2eCommsWrapper from '../../atoms/E2eCommsWrapper/E2eCommsWrapper';
import MainContent from '../../molecules/MainContent/MainContent';
import LegacyFooter from '../../molecules/Footer/Legacy/Footer';
import { isAbsoluteUrl } from '../../../utils/commonUtils.js';
import { AirDropContext } from '../../../utils/AirDropProvider';

function Legacy() {
  const { backgroundImageUrl, cloudfrontRootUrl } = useContext(AirDropContext);

  const LOGIN_PATH = /^(\/login\/static\/img)/;
  const CLOUDFRONT_BASE_URI = `${cloudfrontRootUrl}/img`;

  const getImageUrl = () => {
    const url = backgroundImageUrl;
    if (url && isAbsoluteUrl(url)) {
      return url;
    }
    return url?.replace(LOGIN_PATH, CLOUDFRONT_BASE_URI);
  };

  const bgStyle = getImageUrl() ? { backgroundImage: `url('${getImageUrl()}')` } : {};
  return (
    <div id="pageWrapperLegacy" style={bgStyle}>
      <E2eCommsWrapper />
      <Suspense>
        <BrowserRouter>
          <MainContent />
          <LegacyFooter />
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default Legacy;
